import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";
import { Loader2, ShieldCheck } from "lucide-react";

// booking: { booking_id, total_price, promptpay_qr, promptpay_id, promptpay_name }
export const PromptPayDialog = ({ booking, type = "ride", open, onOpenChange, onConfirmed }) => {
  const [loading, setLoading] = useState(false);
  if (!booking) return null;
  const url = type === "bus"
    ? `/bus/bookings/${booking.booking_id}/confirm-payment`
    : `/bookings/${booking.booking_id}/confirm-payment`;

  const pay = async () => {
    setLoading(true);
    try {
      await api.post(url);
      toast.success("Payment confirmed — enjoy your trip! 🚀");
      onOpenChange(false);
      onConfirmed && onConfirmed();
    } catch (e) {
      toast.error("Could not confirm payment");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-solid text-white border-white/10 max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded bg-[#0A3D62] text-[10px] font-bold text-white">PP</span>
            Pay with PromptPay
          </DialogTitle>
        </DialogHeader>
        <div className="text-center space-y-3" data-testid="promptpay-dialog">
          <div className="bg-white rounded-xl p-3 inline-block mx-auto">
            <img src={booking.promptpay_qr} alt="PromptPay QR code" className="w-56 h-56" data-testid="promptpay-qr-image" />
          </div>
          <div className="font-display text-3xl font-semibold">฿{booking.total_price}</div>
          <p className="text-sm text-muted-cosmic">
            Scan with any Thai bank app (KBank, SCB, Krungthai, Bangkok Bank…) to pay{" "}
            <span className="text-white">{booking.promptpay_name || "Shareride.co"}</span>{booking.promptpay_id ? ` (${booking.promptpay_id})` : ""}.
          </p>
          <div className="flex items-center justify-center gap-1 text-xs text-[#6EE7B7]"><ShieldCheck size={13} /> Secure PromptPay transfer</div>
          <Button data-testid="promptpay-ive-paid-button" onClick={pay} disabled={loading} className="w-full h-11 bg-[hsl(var(--primary))] text-white glow-violet hover:glow-cyan">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "I've paid"}
          </Button>
          <button type="button" onClick={() => onOpenChange(false)} className="text-xs text-muted-cosmic hover:text-white block mx-auto">Pay later</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
